<template>
  <div class="form" style="text-align:left;">
    <div class="title is-4">{{title}}</div>

    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Titel">
          <b-input maxlength="255" v-model="item.title"></b-input>
        </b-field>
      </div>
      <div class="column">
        <!--<b-field label="Bestelldatum">
          <b-input maxlength="255" v-model="item.orderdate"></b-input>
        </b-field>-->

      </div>
    </div>

    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Vorname">
          <b-input maxlength="255" v-model="item.firstname"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Nachname">
          <b-input maxlength="255" v-model="item.lastname"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Email">
          <b-input maxlength="255" v-model="item.email"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Firma">
          <b-input maxlength="255" v-model="item.company"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="PLZ">
          <b-input maxlength="255" v-model="item.companyZipCode"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Ort">
          <b-input maxlength="255" v-model="item.companycity"></b-input>
        </b-field>
      </div>
    </div>


    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Strasse">
          <b-input maxlength="255" v-model="item.companyStreet"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Land">
          <b-input maxlength="255" v-model="item.country"></b-input>
        </b-field>
      </div>
    </div>


    <div v-if="!item.billingAddress" class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Umsatzsteuer-ID">
          <b-input maxlength="255" v-model="item.salesTax"></b-input>
        </b-field>
      </div>
      <div class="column">

      </div>
    </div>

    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Anmerkungen">
          <b-input maxlength="2048" v-model="item.anmerkungen" type="textarea"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Auftragsnummer">
          <b-input maxlength="255" v-model="item.orderNumber"></b-input>
        </b-field>
      </div>
      <div class="column" style="text-align:left;">
        <b-field label="Projektname">
          <b-input maxlength="255" v-model="item.projectName"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Status">
          <b-input maxlength="255" v-model="item.orderStatus"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Order-Code">
          <b-input maxlength="255" v-model="item.orderCode"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Zoho-Code">
          <b-input maxlength="255" v-model="item.zohoCode"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Spiel">
          <b-input  maxlength="255" v-model="item.game"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Format">
          <b-input maxlength="255" v-model="item.format"></b-input>
        </b-field>
      </div>
      <div class="column" style="text-align:left;">
        <b-field label="Umfang">
          <b-input maxlength="255" v-model="item.item"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <b-field label="Verpackung">
          <b-input maxlength="255" v-model="item.package"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Verpackungs-Ausstattung">
          <b-input maxlength="255" v-model="item.packageEquipment"></b-input>
        </b-field>
      </div>
      <div class="column" style="text-align:left;">
        <b-field label="Anzahl Farben">
          <b-input maxlength="255" v-model="item.numberOfcolours"></b-input>
        </b-field>
      </div>
    </div>


    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Quantity1 ">
          <b-input maxlength="255" v-model="item.quantity1"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Quantity2">
          <b-input maxlength="255" v-model="item.quantity2"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Quantity3">
          <b-input maxlength="255" v-model="item.quantity3"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Angebots-Preis">
          <b-input maxlength="2048" v-model="item.offerPrices"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Auftrags-Preis">
          <b-input maxlength="2048" v-model="item.orderPrices"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Druckdaten-Felder">
          <b-input maxlength="255" v-model="item.uploadFields"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Proof-Option">
          <b-input maxlength="255" v-model="item.proofOption"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column" style="text-align:left;">
        <h5 class="title is-5">Produktauswahl</h5>
      </div>
    </div>
    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Umfang">
          <b-input maxlength="255" v-model="item.selectedItem"></b-input>
        </b-field>
      </div>
      <div class="column" style="text-align:left;">
        <b-field label="Preis">
          <b-input maxlength="255" v-model="item.selectedPrice"></b-input>
        </b-field>
      </div>
      <div class="column" style="text-align:left;">
        <b-field label="Menge">
          <b-input maxlength="255" v-model="item.selectedQuantity"></b-input>
        </b-field>
      </div>
      <div class="column" style="text-align:left;">
        <b-field label="Lieferzeit">
          <b-input maxlength="255" v-model="item.selectedProductionTime"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column" style="text-align:left;">
        <h5 class="title is-5">Lieferadresse</h5>
        <b-field>
            <b-checkbox v-model="item.deliveryAddress">
                Abweichende Lieferadresse
            </b-checkbox>
        </b-field>
      </div>
    </div>
    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Firma">
          <b-input maxlength="255" v-model="item.companyDelivery" :disabled="!item.deliveryAddress"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Titel">
          <b-input maxlength="255" v-model="item.titleDelivery" :disabled="!item.deliveryAddress"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Vorname">
          <b-input maxlength="255" v-model="item.firstnameDelivery" :disabled="!item.deliveryAddress"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Nachname ">
          <b-input maxlength="255" v-model="item.lastnameDelivery" :disabled="!item.deliveryAddress"></b-input>
        </b-field>
      </div>
    </div>
    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Strasse">
          <b-input maxlength="255" v-model="item.streetDelivery" :disabled="!item.deliveryAddress"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="PLZ">
          <b-input maxlength="255" v-model="item.zipCodeDelivery" :disabled="!item.deliveryAddress"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Ort">
          <b-input maxlength="255" v-model="item.cityDelivery" :disabled="!item.deliveryAddress"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Land">
          <b-input maxlength="255" v-model="item.countryDelivery" :disabled="!item.deliveryAddress"></b-input>
        </b-field>
      </div>
    </div>
    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Email">
          <b-input maxlength="255" v-model="item.emailDelivery" :disabled="!item.deliveryAddress"></b-input>
        </b-field>
      </div>
      <div class="column" style="text-align:left;">
        <b-field label="Telefon">
          <b-input maxlength="255" v-model="item.telefonDelivery" :disabled="!item.deliveryAddress"></b-input>
        </b-field>
      </div>
    </div>
    <div class="columns">
      <div class="column" style="text-align:left;">
        <h5 class="title is-5">Rechnungsadresse</h5>
        <b-field>
            <b-checkbox v-model="item.billingAddress">
                Abweichende Rechnungsadresse
            </b-checkbox>
        </b-field>
      </div>
    </div>
    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Firma">
          <b-input maxlength="255" v-model="item.companyBilling" :disabled="!item.billingAddress"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Titel">
          <b-input maxlength="255" v-model="item.titleBilling" :disabled="!item.billingAddress"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Vorname">
          <b-input maxlength="255" v-model="item.firstnameBilling" :disabled="!item.billingAddress"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Nachname ">
          <b-input maxlength="255" v-model="item.lastnameBilling" :disabled="!item.billingAddress"></b-input>
        </b-field>
      </div>
    </div>
    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Strasse">
          <b-input maxlength="255" v-model="item.streetBilling" :disabled="!item.billingAddress"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="PLZ">
          <b-input maxlength="255" v-model="item.zipCodeBilling" :disabled="!item.billingAddress"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Ort">
          <b-input maxlength="255" v-model="item.cityBilling" :disabled="!item.billingAddress"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Land">
          <b-input maxlength="255" v-model="item.countryBilling" :disabled="!item.billingAddress"></b-input>
        </b-field>
      </div>
    </div>
    <div v-if="item.billingAddress" class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Umsatzsteuer-ID">
          <b-input maxlength="255" v-model="item.salesTax"></b-input>
        </b-field>
      </div>
      <div class="column">

      </div>
      <div class="column">

      </div>
      <div class="column">

      </div>
    </div>

    <div class="columns">
      <div class="column" style="text-align:left;">
        <h5 class="title is-5">Anschrift für den Proof</h5>
        <b-field>
            <b-checkbox v-model="item.proofAddress">
                Abweichende Anschrift für den Proof
            </b-checkbox>
        </b-field>
      </div>
    </div>
    <div class="columns" :class="">
      <div class="column" style="text-align:left;">
        <b-field label="Firma">
          <b-input maxlength="255" v-model="item.companyProof" :disabled="!item.proofAddress"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Titel">
          <b-input maxlength="255" v-model="item.titleProof" :disabled="!item.proofAddress"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Vorname">
          <b-input maxlength="255" v-model="item.firstnameProof" :disabled="!item.proofAddress"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Nachname ">
          <b-input maxlength="255" v-model="item.lastnameProof" :disabled="!item.proofAddress"></b-input>
        </b-field>
      </div>
    </div>
    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Strasse">
          <b-input maxlength="255" v-model="item.streetProof" :disabled="!item.proofAddress"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="PLZ">
          <b-input maxlength="255" v-model="item.zipCodeProof" :disabled="!item.proofAddress"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Ort">
          <b-input maxlength="255" v-model="item.cityProof" :disabled="!item.proofAddress"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Land">
          <b-input maxlength="255" v-model="item.countryProof" :disabled="!item.proofAddress"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column" >
        <b-button type="is-primary" v-on:click="save()" :disabled="loading">Speichern</b-button>
      </div>
    </div>


  </div>
</template>


<script>
// @ is an alias to /src

import Vue from 'vue'

const axios = require('axios');


export default {
  name: "SingleOrder",
  components: {

},
data() {
      return {
          title: "Neuen Auftrag anlegen",
          item: {},
          loading: true,
        //  item: { 'id': 22, 'name': 'Beidseitig individuelles Kartenset', 'spielart': 'Kartenspiel', 'date': '2016-10-15 13:43:27' },
      }
  },
  watch: {

  },
  mounted: function() {
    console.log("FORM "+ this.$route.params.id);
    if (this.$route.params.id) {
      this.title = "Auftrag bearbeiten";
      //Get-Game
      var _this = this;
      axios.get('/api/orders/'+this.$route.params.id, {
        withCredentials: true,
      })
      .then(function (response) {
        console.log(response.data);
        _this.item = response.data;
          _this.loading = false;
          _this.title = "Auftrag "+_this.item.orderNumber+" bearbeiten";

      })
      .catch(function (error) {
        console.log(error);
      })
      .then(function () {
        // always executed
      });
    } else {
        this.loading = false;
    }

  },
  methods: {
    save: function() {

        //Set-Package
        var _this = this;
        var url = '/api/orders';


        console.log("SAVE");
        console.log(url);
        console.log(this.item);

        axios.put(url, this.item, {
          headers: {
            'Content-Type': 'application/json',
          },
          withCredentials: true,
        })
        .then(function (response) {
          console.log(response.data);
          _this.$router.push({ name: 'orders' })
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
        });


    }
  }
};

</script>
